import createNavItemsViewModel, {
  initialState,
  NavItemsViewModelType
} from '@qpr/components/Expandable/nav-items-view-model';
import React, { useEffect, useState } from 'react';
import { useCurrentTenant } from '@qpr/client-library';
import { useAnchor } from './AppBar';
import MegaMenu from './MegaMenu';

const MegaMenuView = () => {
  const viewModel: NavItemsViewModelType = createNavItemsViewModel();

  const [megaData, setMegaData] = useState(initialState);
  const [inited, setInited] = useState(false);

  const tenant = useCurrentTenant();

  useEffect(() => {
    setInited(false);
    async function initData() {
      const gotData = await viewModel.getNavItems();
      setMegaData(gotData.data);
      setInited(true);
    }
    initData();
  }, []);

  const anchorElement: React.MutableRefObject<null> = useAnchor();

  return (
    <MegaMenu
      anchorElement={anchorElement}
      inited={inited}
      megaData={megaData}
      tenantSymbol={tenant.symbol}
    />
  );
};

export default MegaMenuView;
